export default class Product {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    id: 'string',
    name: 'string',
    shortName: 'any?',
    price: 'number',
    description: 'any?',
    validityPeriod: 'any?',
    validityPeriodInMonths: 'any?',
    validityPeriodInDays: 'any?',
    productCode: 'string',
    productDescription: 'string',
    commodityCode: 'string',
    unitOfMeasure: 'string',
    alternateTaxID: 'any?',
    //Compatibility
    id: 'any?',
    tenantID: 'any?',
    createdBy: 'any?',
    updatedBy: 'any?',
    updatedOn: 'any?',
    createdOn: 'any?',
    transactionID: 'any?',
  }
  */
  async createProduct(productObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/product/' + productObj.id;
    req.body = productObj;
    return await req.exec();
  }
  async updateProduct(productObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/product/' + productObj.id;
    req.body = productObj;
    return await req.exec();
  }
  async deleteProduct(productID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/product/' + productID;
    return await req.exec();
  }
  async getProduct(productID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/product/' + productID;
    return await req.exec();
  }
  async getAllProducts() {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/products/';
    return await req.exec();
  }
  async getAllProductsAgnostic() {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/products/all';
    return await req.exec();
  }
}
